<template>
  <div>
    <div class="toolbtn flex">
      <el-tooltip class="item" effect="dark" content="返回" placement="top">
        <callback></callback>
      </el-tooltip>
    </div>
    <div class="flex">
      <div class="itemblock" @click="detailmonth()">
        <i
          slot="prefix"
          class="iconfont icon-fenlei"
          style="font-size: 50px; color: #fff"
        ></i>
      </div>
      <div class="itemblock margin-left20" @click="detailproject()">
        <i
          slot="prefix"
          class="iconfont icon-bijibennotebook431"
          style="font-size: 50px; color: #fff"
        ></i>
      </div>
    </div>
    <div class="flex f14 margin-top10">
      <p style="width: 140px; color: #52c5cb" class="textalign-center">
        日期区间生成辅助账
      </p>
      <p
        style="width: 140px; color: #52c5cb"
        class="margin-left20 textalign-center"
      >
        按项目生成辅助账
      </p>
    </div>
    <el-dialog
      title=""
      :visible.sync="dialogVisiblenull"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="25%"
      class="errorbox"
    >
      <p class="textalign-left f16">提示</p>
      <div class="textalign-left margin-top10">
        <span class="errormessage">{{ errormessage }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <span @click="dialogVisiblenulls()" class="errorbutton"> 确 定 </span>
      </span>
    </el-dialog>
    <!-- 按月份查询明细弹窗 -->
    <el-dialog
      title=""
      :visible.sync="dialogVisibledetailmonth"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      :width="detailmonthwidth"
    >
      <p class="textalign-left f16">研发辅助账（日期区间）</p>
      <div class="margin-top30 pad-bot20" id="printTest">
        <div class="textalign-left">
          <div class="waterbor" v-if="detailindex == 1">
            <div class="width90 margin-auto margin-top30 pad-bot30">
              <p class="maincolor f16">请选择要查询的区间</p>
              <div class="width100 margin-top20">
                <el-date-picker
                  v-model="yearsection"
                  type="monthrange"
                  style="width: 100%"
                  range-separator="-"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM"
                  :picker-options="pickerOptions"
                >
                </el-date-picker>
              </div>
              <div
                class="margin-top20 border-rd3"
                style="background: #52c5cc80"
              >
                <div
                  class="width90 margin-auto lineheight25 pad-top10 pad-bot10"
                >
                  采用按月分组展示研发工资明细。
                </div>
              </div>
              <div class="margin-top20">
                <el-button type="primary" @click="detailmonthmoney()"
                  >查看研发辅助账</el-button
                >
                <el-button
                  @click="dialogVisibledetailmonth = false"
                  class="resetbtn"
                  >取 消</el-button
                >
              </div>
            </div>
          </div>
          <div class="waterbor pad-bot30" v-if="detailindex == 2">
            <div class="loading"></div>
            <p class="maincolor f16 textalign-center pad-top20">
              正在查询{{
                yearsection[0] + " - " + yearsection[1]
              }}工资明细，请稍候
            </p>
          </div>
          <div v-if="detailindex == 3">
            <div
              class="
                width96
                margin-auto
                backwhite
                margin-top10
                border-rd3
                margin-top40
                posrtionre
              "
              style="border: 2px solid #878787"
              v-for="(item, index) in detailmonthcont"
              :key="index"
            >
              <p class="maincolor margin-top10 margin-bot10 monthcont">
                月份:{{
                  detailmonthcont[index].list[0].fee_date.substring(0, 7)
                }}
              </p>
              <!-- 费用名称 -->
              <div
                class="width100 flex-betweenNowrapAligns textalign-center f12"
              >
                <div class="width30" style="height: 150px">
                  <div
                    style="height: 40px; line-height: 40px"
                    class="botborder"
                  >
                    凭证信息
                  </div>
                  <div style="height: 110px" class="flex-betweenNowrapAligns">
                    <div class="width40 textalign-center ritborder botborder">
                      <p class="pad-top30">日期</p>
                    </div>
                    <div class="width60 textalign-center botborder">
                      <p class="pad-top30">种类</p>
                    </div>
                  </div>
                </div>
                <div class="width70" style="height: 150px">
                  <div class="flex-betweenwrap width100">
                    <div
                      class="width100 heitlinhet botborder leftborder"
                      style="height: 40px; line-height: 40px"
                    >
                      费用明细
                    </div>
                    <div
                      class="flex-betweenNowrapAlign botborder"
                      style="height: 109px"
                    >
                      <div class="width12 leftborder" style="height: 109px">
                        <p class="pad-top30">人员人工费用</p>
                      </div>
                      <div class="width12 leftborder" style="height: 109px">
                        <p class="pad-top30">直接投入费用</p>
                      </div>
                      <div class="width12 leftborder" style="height: 109px">
                        <p class="pad-top30">折旧费用</p>
                      </div>
                      <div class="width12 leftborder" style="height: 109px">
                        <p class="pad-top30">无形资产摊销</p>
                      </div>
                      <div class="width12 leftborder" style="height: 109px">
                        <p class="pad-top30">新产品设计费等</p>
                      </div>
                      <div
                        class="width12 leftborder ritborder"
                        style="height: 109px"
                      >
                        <p class="pad-top30">其他相关费用</p>
                      </div>
                      <div class="width28" style="height: 109px">
                        <div class="width100 heitlinhet botborder">
                          委托研发费用
                        </div>
                        <div class="flex-aroundnowrapcev">
                          <div class="width50" style="height: 80px">
                            委托境内机构或个人进行研发活动所发生的费用
                          </div>
                          <div class="width50 leftborder" style="height: 80px">
                            委托境外机构进行研发活动所发生的费用
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 费用明细 -->
              <div
                class="
                  width100
                  flex-betweenNowrapAligns
                  textalign-center
                  f12
                  botborder
                "
                v-for="(_item, _index) in item.list"
                :key="_index"
              >
                <div class="width30 heitlinhet flex-betweenNowrapAligns">
                  <div class="width40 textalign-center ritborder">
                    {{ _item.fee_date }}
                  </div>
                  <div class="width60 textalign-center">
                    {{ _item.small_class }}
                  </div>
                </div>
                <div class="flex-betweenNowrapAligns width70 heitlinhet">
                  <div class="width12 heitlinhet leftborder">
                    <span v-if="_item.big_class_id == 1">{{
                      _item.amount
                    }}</span>
                  </div>
                  <div class="width12 heitlinhet leftborder">
                    <span v-if="_item.big_class_id == 3">{{
                      _item.amount
                    }}</span>
                  </div>
                  <div class="width12 heitlinhet leftborder">
                    <span v-if="_item.big_class_id == 10">{{
                      _item.amount
                    }}</span>
                  </div>
                  <div class="width12 heitlinhet leftborder">
                    <span v-if="_item.big_class_id == 13">{{
                      _item.amount
                    }}</span>
                  </div>
                  <div class="width12 heitlinhet leftborder">
                    <span v-if="_item.big_class_id == 17">{{
                      _item.amount
                    }}</span>
                  </div>
                  <div class="width12 heitlinhet leftborder">
                    <span v-if="_item.big_class_id == 22">{{
                      _item.amount
                    }}</span>
                  </div>
                  <div class="width28 flex-betweenNowrapAligns heitlinhet">
                    <div class="width50 heitlinhet leftborder"></div>
                    <div class="width50 heitlinhet leftborder">
                      <span v-if="_item.big_class_id == 27">{{
                        _item.amount
                      }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 合计金额 -->
              <div
                class="width100 flex-betweenNowrapAligns textalign-center f12"
              >
                <div
                  class="width30 heitlinhet ritborder"
                  style="padding-right: 1px"
                >
                  合计金额
                </div>
                <div class="flex-betweenNowrapAligns width70 heitlinhet">
                  <div class="width12 heitlinhet ritborder">
                    <span>{{ allSum[index][1] }}</span>
                  </div>
                  <div class="width12 heitlinhet ritborder">
                    <span>{{ allSum[index][3] }}</span>
                  </div>
                  <div class="width12 heitlinhet ritborder">
                    <span>{{ allSum[index][10] }}</span>
                  </div>
                  <div class="width12 heitlinhet ritborder">
                    <span>{{ allSum[index][13] }}</span>
                  </div>
                  <div class="width12 heitlinhet ritborder">
                    <span>{{ allSum[index][17] }}</span>
                  </div>
                  <div class="width12 heitlinhet ritborder">
                    <span>{{ allSum[index][22] }}</span>
                  </div>
                  <div class="width28 flex-betweenNowrapAligns heitlinhet">
                    <div class="width50 heitlinhet ritborder">0</div>
                    <div class="width50 heitlinhet">
                      <span>{{ allSum[index][27] }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <p class="textalign-right" v-if="detailindex == 3">
        <el-button type="primary" v-print="'#printTest'">打 印</el-button>
        <el-button @click="dialogVisibledetailmonth = false">取 消</el-button>
      </p>
    </el-dialog>
    <!-- 按项目查询明细弹窗 -->
    <el-dialog
      title=""
      :visible.sync="dialogVisibleproject"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      :width="projectwidth"
    >
      <p class="textalign-left f16">研发辅助账（项目）</p>
      <div class="margin-top30 pad-bot20" id="printTests">
        <div class="textalign-left">
          <div class="waterbor" v-if="projectindex == 1">
            <div class="width90 margin-auto margin-top30 pad-bot30">
              <p class="maincolor f16">请选择要查询的区间</p>
              <div class="width100 margin-top20">
                <el-select
                  style="width: 100%"
                  v-model="projectvalue"
                  placeholder="请选择"
                >
                  <el-option
                    style="width: 100%"
                    v-for="item in projectoptions"
                    :key="item.id"
                    :label="item.title"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </div>
              <div
                class="margin-top20 border-rd3"
                style="background: #52c5cc80"
              >
                <div
                  class="width90 margin-auto lineheight25 pad-top10 pad-bot10"
                >
                  研发项目工资明细，采用按月分组展示。
                </div>
              </div>
              <div class="margin-top20">
                <el-button type="primary" @click="projectmoney()"
                  >查看研发辅助账</el-button
                >
                <el-button
                  @click="dialogVisibleproject = false"
                  class="resetbtn"
                  >取 消</el-button
                >
              </div>
            </div>
          </div>
          <div class="waterbor pad-bot30" v-if="projectindex == 2">
            <div class="loading"></div>
            <p class="maincolor f16 textalign-center pad-top20">
              项目名称:{{ projecttitle }}
            </p>
          </div>
          <div v-if="projectindex == 3">
            <div
              class="
                width96
                margin-auto
                backwhite
                margin-top10
                border-rd3
                margin-top40
                posrtionre
              "
              style="border: 2px solid #878787"
              v-for="(item, index) in projectcont"
              :key="index"
            >
              <p class="maincolor margin-top10 margin-bot10 monthcont">
                月份:{{ projectcont[index].list[0].fee_date.substring(0, 7) }}
              </p>
              <!-- 费用名称 -->
              <div
                class="width100 flex-betweenNowrapAligns textalign-center f12"
              >
                <div class="width30" style="height: 150px">
                  <div
                    style="height: 40px; line-height: 40px"
                    class="botborder"
                  >
                    凭证信息
                  </div>
                  <div style="height: 110px" class="flex-betweenNowrapAligns">
                    <div class="width40 textalign-center ritborder botborder">
                      <p class="pad-top30">日期</p>
                    </div>
                    <div class="width60 textalign-center botborder">
                      <p class="pad-top30">种类</p>
                    </div>
                  </div>
                </div>
                <div class="width70" style="height: 150px">
                  <div class="flex-betweenwrap width100">
                    <div
                      class="width100 heitlinhet botborder leftborder"
                      style="height: 40px; line-height: 40px"
                    >
                      费用明细
                    </div>
                    <div
                      class="flex-betweenNowrapAlign botborder"
                      style="height: 109px"
                    >
                      <div class="width12 leftborder" style="height: 109px">
                        <p class="pad-top30">人员人工费用</p>
                      </div>
                      <div class="width12 leftborder" style="height: 109px">
                        <p class="pad-top30">直接投入费用</p>
                      </div>
                      <div class="width12 leftborder" style="height: 109px">
                        <p class="pad-top30">折旧费用</p>
                      </div>
                      <div class="width12 leftborder" style="height: 109px">
                        <p class="pad-top30">无形资产摊销</p>
                      </div>
                      <div class="width12 leftborder" style="height: 109px">
                        <p class="pad-top30">新产品设计费等</p>
                      </div>
                      <div
                        class="width12 leftborder ritborder"
                        style="height: 109px"
                      >
                        <p class="pad-top30">其他相关费用</p>
                      </div>
                      <div class="width28" style="height: 109px">
                        <div class="width100 heitlinhet botborder">
                          委托研发费用
                        </div>
                        <div class="flex-aroundnowrapcev">
                          <div class="width50" style="height: 80px">
                            委托境内机构或个人进行研发活动所发生的费用
                          </div>
                          <div class="width50 leftborder" style="height: 80px">
                            委托境外机构进行研发活动所发生的费用
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 费用明细 -->
              <div
                class="
                  width100
                  flex-betweenNowrapAligns
                  textalign-center
                  f12
                  botborder
                "
                v-for="(_item, _index) in item.list"
                :key="_index"
              >
                <div class="width30 heitlinhet flex-betweenNowrapAligns">
                  <div class="width40 textalign-center ritborder">
                    {{ _item.fee_date }}
                  </div>
                  <div class="width60 textalign-center">
                    {{ _item.small_class }}
                  </div>
                </div>
                <div class="flex-betweenNowrapAligns width70 heitlinhet">
                  <div class="width12 heitlinhet leftborder">
                    <span v-if="_item.big_class_id == 1">{{
                      _item.amount
                    }}</span>
                  </div>
                  <div class="width12 heitlinhet leftborder">
                    <span v-if="_item.big_class_id == 3">{{
                      _item.amount
                    }}</span>
                  </div>
                  <div class="width12 heitlinhet leftborder">
                    <span v-if="_item.big_class_id == 10">{{
                      _item.amount
                    }}</span>
                  </div>
                  <div class="width12 heitlinhet leftborder">
                    <span v-if="_item.big_class_id == 13">{{
                      _item.amount
                    }}</span>
                  </div>
                  <div class="width12 heitlinhet leftborder">
                    <span v-if="_item.big_class_id == 17">{{
                      _item.amount
                    }}</span>
                  </div>
                  <div class="width12 heitlinhet leftborder">
                    <span v-if="_item.big_class_id == 22">{{
                      _item.amount
                    }}</span>
                  </div>
                  <div class="width28 flex-betweenNowrapAligns heitlinhet">
                    <div class="width50 heitlinhet leftborder"></div>
                    <div class="width50 heitlinhet leftborder">
                      <span v-if="_item.big_class_id == 27">{{
                        _item.amount
                      }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 合计金额 -->
              <div
                class="width100 flex-betweenNowrapAligns textalign-center f12"
              >
                <div
                  class="width30 heitlinhet ritborder"
                  style="padding-right: 1px"
                >
                  合计金额
                </div>
                <div class="flex-betweenNowrapAligns width70 heitlinhet">
                  <div class="width12 heitlinhet ritborder">
                    <span>{{ projectSum[index][1] }}</span>
                  </div>
                  <div class="width12 heitlinhet ritborder">
                    <span>{{ projectSum[index][3] }}</span>
                  </div>
                  <div class="width12 heitlinhet ritborder">
                    <span>{{ projectSum[index][10] }}</span>
                  </div>
                  <div class="width12 heitlinhet ritborder">
                    <span>{{ projectSum[index][13] }}</span>
                  </div>
                  <div class="width12 heitlinhet ritborder">
                    <span>{{ projectSum[index][17] }}</span>
                  </div>
                  <div class="width12 heitlinhet ritborder">
                    <span>{{ projectSum[index][22] }}</span>
                  </div>
                  <div class="width28 flex-betweenNowrapAligns heitlinhet">
                    <div class="width50 heitlinhet ritborder">0</div>
                    <div class="width50 heitlinhet">
                      <span>{{ projectSum[index][27] }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <p class="textalign-right" v-if="projectindex == 3">
        <el-button type="primary" v-print="'#printTests'">打 印</el-button>
        <el-button @click="dialogVisibleproject = false">取 消</el-button>
      </p>
    </el-dialog>
  </div>
</template>
<script>
import callback from "@/components/callback.vue";
import {
  entassistrecordindex,
  researchprojects,
} from "@/api/newhead/newhead.api";
export default {
  data() {
    return {
      errormessage: "",
      dialogVisiblenull: false,
      dialogVisibleRunning: false,
      dialogVisibledetailmonth: false,
      dialogVisibleproject: false,
      ruleForm: {
        inputyear: "",
        patent_type: "",
      },
      inputmonth: "",
      waterindex: 1,
      yearsection: "",
      detailindex: 1,
      detailmonthwidth: 30 + "%",
      detailmonthcont: [],
      allSum: [],

      projectindex: 1,
      projectwidth: 30 + "%",
      projectvalue: "",
      projectoptions: [],
      projectcont: [],
      projecttitle: "",
      projectSum: [],

      options: [],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
    };
  },
  components: {
    callback,
  },
  methods: {
    // 按月份查询明细
    detailmonth() {
      this.dialogVisibledetailmonth = true;
      this.detailindex = 1;
      this.detailmonthwidth = 30 + "%";
      this.allSum = [];
    },
    detailmonthmoney() {
      if (this.yearsection != "") {
        this.detailindex = 2;
        entassistrecordindex({
          month: this.yearsection[0] + " - " + this.yearsection[1],
          method: "by_date",
        }).then((res) => {
          if (res.data.code == 200) {
            this.detailindex = 3;
            this.detailmonthwidth = 70 + "%";
            this.detailmonthcont = Object.values(res.data.data);

            let obj = { ...res.data.data };
            for (let k in obj) {
              const Sum = obj[k].list.reduce(
                (prev, { big_class_id, amount }) => {
                  return (
                    (prev[big_class_id] =
                      (prev[big_class_id] || 0) + Number(amount)),
                    prev
                  );
                },
                {}
              );

              this.allSum.push(Sum);
            }
          } else {
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        });
      } else {
        return;
      }
    },
    // 按项目查询明细
    detailproject() {
      this.dialogVisibleproject = true;
      this.projectindex = 1;
      this.projectwidth = 30 + "%";
      this.projectSum = [];
    },
    projectmoney() {
      if (this.projectvalue != "") {
        this.projectindex = 2;
        entassistrecordindex({
          project_id: this.projectvalue,
          method: "by_project",
        }).then((res) => {
          if (res.data.code == 200) {
            this.projectindex = 3;
            this.projectwidth = 70 + "%";
            this.projectcont = Object.values(res.data.data);

            let obj = { ...res.data.data };
            for (let k in obj) {
              const Sum = obj[k].list.reduce(
                (prev, { big_class_id, amount }) => {
                  return (
                    (prev[big_class_id] =
                      (prev[big_class_id] || 0) + Number(amount)),
                    prev
                  );
                },
                {}
              );

              this.projectSum.push(Sum);
            }
          } else {
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        });
      } else {
        return;
      }
    },
    dialogVisiblenulls() {
      this.dialogVisiblenull = false;
      this.dialogVisibleproject = false;
      this.dialogVisibledetailmonth = false;
    },
  },
  created() {
    researchprojects({}).then((res) => {
      if (res.data.code == 200) {
        this.projectoptions = res.data.data.data;
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
  },
};
</script>
<style scoped>
/* 调用window.print()时生效的样式 */
@media print {
  @page {
    /* 横向 */
    /* size: landscape; */
    /* 去除浏览器默认页眉页脚 */
    margin: 0;
  }
  /* 给需要打印的区域内或同级不需要打印的元素加上这个类 */
  .noprint {
    display: none;
  }
  /* 这里的id我用于选中modal，然后给其中背景色设置为透明，去掉弹窗头和脚及阴影 */
  #printTests {
    /* 默认打印内容区背景色*/
    /* -webkit-print-color-adjust: exact; */
    border: solid white !important;
    background-color: #fff !important;
  }
}
/* 调用window.print()时生效的样式 */
@media print {
  @page {
    /* 横向 */
    /* size: landscape; */
    /* 去除浏览器默认页眉页脚 */
    margin: 0;
  }
  /* 给需要打印的区域内或同级不需要打印的元素加上这个类 */
  .noprint {
    display: none;
  }
  /* 这里的id我用于选中modal，然后给其中背景色设置为透明，去掉弹窗头和脚及阴影 */
  #printTests {
    /* 默认打印内容区背景色*/
    /* -webkit-print-color-adjust: exact; */
    border: solid white !important;
    background-color: #fff !important;
  }
}
/* 需要打印的区域*/
.printable {
  display: block;
}
.itemblock {
  width: 140px;
  height: 110px;
  border-radius: 3px;
  background: #52c5cb;
  text-align: center;
  line-height: 110px;
}
.itemblock:hover {
  cursor: pointer;
  background: #8ad3d8;
}
.loading {
  width: 100px;
  height: 100px;
  border: 2px solid #52c5cb;
  margin: 40px auto 20px;
  border-top-color: transparent;
  border-radius: 50%;
  animation: rotate 0.75s linear infinite;
}

@keyframes rotate {
  to {
    transform: rotate(360deg);
  }
}

.maincolor {
  color: #52c5cb;
}
.monthcont {
  position: absolute;
  top: -35px;
}
.topborder {
  border-top: 1px solid #6e6e6e;
}
.botborder {
  border-bottom: 1px solid #6e6e6e;
}
.ritborder {
  border-right: 1px solid #6e6e6e;
}
.leftborder {
  border-left: 1px solid #6e6e6e;
}
.heitlinhet {
  min-height: 30px;
  line-height: 30px;
}
.errorbox >>> .el-dialog__body {
  text-align: center;
}
.errorbox >>> .el-dialog {
  position: relative;
  top: 20%;
}
</style>